import React from "react";
import I18n from "i18n";
import session from "models/sessionInstance";
import vent from "libraries/vent";

interface Props {
  agentResult: any; // Backbone.Model (SelectedAgentResults)
}

export default function DetailHeaderCreateReport({ agentResult }: Props) {
  function handleReport(type: "Medienspiegel" | "ExcelReport" | "Newsletter") {
    const clipId = [agentResult.get("clip_id")];
    vent.trigger("reporting:new:report", {
      topic_ids: clipId,
      topic_type: "clip",
      type,
    });
  }

  return (
    <div className="dropdown link-bar__left-item">
      <a
        className="dropdown__toggle"
        data-toggle="dropdown"
        id="result_create_report_dd"
      >
        <i className="icon-file"></i>{" "}
        {I18n.t("webapp.agents.results.multiple_results.create_report")}{" "}
        <i className="icon-triangle-down"></i>
      </a>
      <ul className="dropdown__menu" role="menu">
        {session.get("features").reports_pdf_export && (
          <li
            data-pdf-export-button
            className="dropdown__item"
            onClick={() => handleReport("Medienspiegel")}
          >
            <a className="dropdown__link">
              {I18n.t("webapp.agents.results.multiple_results.clipping_report")}
            </a>
          </li>
        )}
        {session.get("features").reports_excel_export && (
          <li
            data-excel-export-button
            className="dropdown__item"
            onClick={() => handleReport("ExcelReport")}
          >
            <a className="dropdown__link">
              {I18n.t("webapp.agents.results.multiple_results.excel_export")}
            </a>
          </li>
        )}
        {session.get("features").reports_newsletter && (
          <li
            data-newsletter-report-button
            className="dropdown__item"
            onClick={() => handleReport("Newsletter")}
          >
            <a className="dropdown__link">
              {I18n.t("webapp.agents.results.multiple_results.newsletter")}
            </a>
          </li>
        )}
      </ul>
    </div>
  );
}